module.exports = __webpack_public_path__ + "img/wedding.7508e2aa.jpg";